export default {
      id: "form-preview-down-usage",
      viewBox: "0 0 375 164",
      url: __webpack_public_path__ + "icons.svg#form-preview-down",
      toString: function () {
        return this.url;
      }
    }